import React from 'react';
import { Link } from 'react-router-dom';
import ProjectsSection from '../components/sections/ProjectsSection';
import './PageLayout.css';

const ProjectsPage = () => {
  return (
    <div className="page-layout">
      <Link to="/" className="back-button">← Home</Link>
      <div className="page-content">
        <ProjectsSection />
      </div>
    </div>
  );
};

export default ProjectsPage;

